import { Table } from 'antd';
import styled from 'styled-components';
import { Type } from '../../../api/responses';
import { theme } from '../../../global';

export const TimeContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${theme.spacings.s8};
`;

export const GroupName = styled.span`
  font-family: 'Montserrat';
  font-size: 14px;
  font-weight: 600;
`;

export const PlayersHeader = styled.div`
  display: flex;
  gap: ${theme.spacings.s8};
  font-family: 'Montserrat';
  font-weight: 600;
  font-size: 14px;
  line-height: 100%;
  align-items: center;
`;

export const TimeBadge = styled.div`
  width: 100px;
  height: 25px;
  border-radius: ${theme.spacings.s4};
  padding: ${theme.spacings.s4} 0;
  background: ${theme.colors.purple};
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  font-family: 'Montserrat';
  font-size: 14px;
  font-weight: 500;
  color: ${theme.colors.primaryText};
`;

export const ScheduleItemContainer = styled.div<{ $isLast?: boolean }>`
  padding: ${theme.spacings.s24} 0;
  border-bottom: ${(props) =>
        props.$isLast ? 'none' : `1px solid ${theme.colors.line}`};
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: ${theme.spacings.s16};
`;

export const ScheduleItemContent = styled.span`
  flex: 1;
  font-family: 'Montserrat';
  font-size: 14px;
  font-weight: 500;
  color: ${theme.colors.primaryText};
`;

export const DividedCell = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  justify-content: center;
`;

export const CellRow = styled.div<{ $hasBorder?: boolean }>`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 50%;
  min-height: 40px;
  //padding: 8px 4px;
  position: relative;

  ${(props) =>
        props.$hasBorder &&
        `
    &::after {
      content: '';
      position: absolute;
      bottom: 0;
      left: 8px;
      right: 8px;
      height: 0;
      border-bottom: 1px solid #17171726;
    }
  `}
`;

export const StyledTable = styled(Table) <{ $competitionType: Type }>`
  width: 1200px;

  /* Убираем все скругления */
  .ant-table-container,
  .ant-table-container table > thead > tr:first-child > *:first-child,
  .ant-table-container table > thead > tr:first-child > *:last-child,
  .ant-table-container table > tbody > tr:last-child > *:first-child,
  .ant-table-container table > tbody > tr:last-child > *:last-child {
    border-radius: 0 !important;
  }

  .ant-table-thead > tr > th {
    height: auto;
    padding: 0;
    background: ${(props) => {
        switch (props.$competitionType) {
            case 'team':
                return theme.colors.greenHeader;
            case 'quick':
                return theme.colors.orangeHeader;
            case 'classic':
                return theme.colors.purpleHeader;
            default:
                return theme.colors.purpleHeader;
        }
    }} !important;
    font-family: 'Montserrat';
    font-size: 14px;
    font-weight: 600;
    color: ${theme.colors.secondaryText};
    border: none;
    vertical-align: middle;
  }

  .ant-table-tbody > tr > td {
    padding: 0;
    border-bottom: 1px solid ${theme.colors.line};
    font-family: 'Montserrat';
    font-size: 14px;
    text-align: center;
    border-right: none;
    border-left: none;
    vertical-align: top;
    height: 80px;
  }

  .ant-table-container {
    border-radius: 0;
    overflow: hidden;
    border: none;
  }

  .ant-table {
    border-spacing: 0;
    border-collapse: collapse;
  }

  .ant-table-thead > tr > th,
  .ant-table-tbody > tr > td {
    border-right: none;
    border-left: none;
  }

  .ant-table-tbody > tr:last-child > td {
    border-bottom: none;
  }

  .ant-table-tbody > tr > td {
    display: table-cell;
    vertical-align: middle;
  }
`;

export const PlayerNumber = styled.div<{ $playerNumber: number }>`
  width: 20px;
  height: 20px;
  opacity: 1;
  border-radius: 2px;
  padding-top: 3px;
  padding-bottom: 3px;
  font-family: 'Montserrat';
  font-size: 14px;
  font-weight: 700;
  display: flex;
  align-items: center;
  justify-content: center;
  color: ${theme.colors.white};
  background: ${(props) =>
        props.$playerNumber === 1 ? '#828091' : theme.colors.blue};
        flex-shrink: 0;
`;

export const PlayerRow = styled.div<{ $hasBorder?: boolean }>`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 50%;
  min-height: 40px;
  //padding: 8px 4px;
  position: relative;
  gap: ${theme.spacings.s8};
  font-family: Montserrat;
  font-size: 14px;
  font-weight: 600;
  line-height: 100%;
  letter-spacing: 0%;

  ${(props) =>
        props.$hasBorder &&
        `
    &::after {
      content: '';
      position: absolute;
      bottom: 0;
      left: 8px;
      right: 8px;
      height: 0;
      border-bottom: 1px solid #17171726;
    }
  `}
`;

export const RoundDescription = styled.div`
  font-family: 'Montserrat';
  font-size: 16px;
  font-weight: 700;
  padding-top: ${theme.spacings.s24};
`;

export const Attention = styled.div`
  font-family: 'Montserrat';
  font-size: 14px;
  font-weight: 600;
  margin-top: ${theme.spacings.s8};
  color: #E23353;
`;

export const Line = styled.hr`
  border-top: 1px solid ${theme.colors.line};
  width: 100%;
  margin-top: ${theme.spacings.s24};
`;
